// noinspection GraphQLUnresolvedReference

export const listFilteredColors = /*GraphQL */ `
    query ListFilteredColors($color: [QueryArgument], $category: [QueryArgument], $finishing: [QueryArgument], $coverIds:[QueryArgument], $search:String) {
        colorCatalogEntries(
            relatedToEntries: [{section: "finishing", id: $finishing}, {section: "covers", category: $category, id: $coverIds}]
        ) {
            ... on colorCatalog_Entry {
                _count(field: "colors")
                colors(hue: $color, orderBy: "title ASC", search: $search) {
                    id
                    title
                    url(width: 50, height: 50)
                }
            }
        }
    }
`;

export const listColorFilters = /*GraphQL*/ `
    query ListColorFilters {
        hueEntries {
            ... on hue_Entry {
                id
                color
                title
            }
        }
    }
`;

export const listCatalogFinishingColors = /*GraphQL*/ `
    query ListCatalogFinishingColors($id: [QueryArgument]) {
        colorCatalogEntries(relatedToEntries: {section: "finishing", id: $id}) {
            ... on colorCatalog_Entry {
                colors {
                    ... on images_Asset {
                        hue {
                            ... on hue_Entry {
                                id
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const getColorCartInfo = /*GraphQL*/ `
    query GetColorCartInfo($id: [QueryArgument], $cover: [QueryArgument]) {
        chairEntries(id: $id) {
            ... on variant_Entry {
                variantCost {
                    ... on variantCostBlock_Entry {
                        coverCost
                        cover {
                            title
                            ... on cover_Entry {
                                collection {
                                    ... on colorCatalog_Entry {
                                        patternRepeat
                                        shininess
                                        id
                                        detailInformation
                                        title
                                        colors(id: $cover) {
                                            id
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
